import { ids } from "@icarros/theme-react";
import { Contrast } from "../../../types/general.types";
const { color, opacity } = ids || {};
import { IconVariants } from "./constants";
import { hexToRgba } from "@icarros/utils-react";
const getContrastStyles = (contrast, isColorVariant, isDisabled) => {
    switch (contrast) {
        case Contrast.dark: {
            if (isColorVariant)
                return color.contrast.ids_color_contrast_onDark;
            if (isDisabled)
                return color.contrast.ids_color_contrast_onDark;
            return color.contrast.ids_color_contrast_onDark;
        }
        case Contrast.light: {
            if (isColorVariant)
                return color.contrast.ids_color_contrast_onLight_strong;
            if (isDisabled)
                return color.contrast.ids_color_contrast_onLight_medium;
            return color.contrast.ids_color_contrast_onLight;
        }
    }
    return;
};
export const getIconColor = ({ isError, isDisabled, variant, isColorVariant, contrast, }) => {
    if (isError) {
        return color.feedbacks.ids_color_feedback_error;
    }
    if (isDisabled) {
        if (contrast === "dark") {
            return hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium);
        }
        return hexToRgba(color.action.disabled.ids_color_action_disabled_variant, opacity.ids_opacity_medium);
    }
    if (contrast && contrast !== Contrast.default) {
        return getContrastStyles(contrast, isColorVariant, isDisabled);
    }
    switch (variant) {
        case IconVariants.neutral: {
            if (isColorVariant)
                return color.action.neutral.ids_color_action_neutral_variant;
            return color.action.neutral.ids_color_action_neutral_base;
        }
        case IconVariants.primary: {
            if (isColorVariant)
                return color.action.primary.ids_color_action_primary_variant;
            return color.action.primary.ids_color_action_primary_base;
        }
        case IconVariants.secondary: {
            if (isColorVariant)
                return color.action.secondary.ids_color_action_secondary_base;
            return color.action.secondary.ids_color_action_secondary_variant;
        }
        case IconVariants.positive: {
            return color.feedbacks.ids_color_feedback_success;
        }
        case IconVariants.negative:
            return color.feedbacks.ids_color_feedback_alert;
    }
    ;
    return;
};
//# sourceMappingURL=Icon.style.js.map